// src/app/pipes/youtube-embed.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'youtubeEmbed',
})
export class YoutubeEmbedPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string): SafeHtml {
    if (!html) return '';

    const replaced = html.replace(
      /<figure class="media">\s*<div data-oembed-url="([^"]+)">\s*<div[^>]*>\s*<\/div>\s*<\/div>\s*<\/figure>/gi,
      (_, url: string) => {
        const match = url.match(
          /(?:youtu\.be\/|youtube\.com\/watch\?v=|youtube\.com\/embed\/)([A-Za-z0-9_-]+)/,
        );
        if (!match) return '';

        const videoId  = match[1];
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;

        return `
          <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;margin:20px 0">
            <iframe
              src="${embedUrl}"
              style="position:absolute;top:0;left:0;width:100%;height:100%;border:0"
              allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share"
              allowfullscreen>
            </iframe>
          </div>
        `;
      },
    );

    return this.sanitizer.bypassSecurityTrustHtml(replaced);
  }
}
